export default "__VITE_ASSET__379d8364__"